import { api } from "./api";
import { isStandalone } from "./install";

const KEY = "tf.handoff";
const IN_APP = /FBAN|FBAV|FB_IAB|Instagram|Messenger|Line\/|LinkedInApp|Snapchat|TikTok|Twitter|MicroMessenger|GSA\/|; wv\)/i;

export const isInAppBrowser = () => IN_APP.test(navigator.userAgent || "");

function nonce() {
  const a = new Uint8Array(24);
  crypto.getRandomValues(a);
  return Array.from(a, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function startGoogleSignIn() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  if (isStandalone()) {
    // Home-screen apps may finish Google sign-in in a browser tab that shares storage; a one-time code hands the login back.
    localStorage.setItem(KEY, JSON.stringify({ n: nonce(), at: Date.now() }));
  }
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function pendingHandoff() {
  try {
    const h = JSON.parse(localStorage.getItem(KEY) || "null");
    if (h && Date.now() - h.at < 10 * 60 * 1000) return h.n;
  } catch {}
  localStorage.removeItem(KEY);
  return null;
}

export async function claimHandoff(n) {
  const { data } = await api.get(`/auth/handoff/${n}`, { timeout: 10000 });
  if (data.ready) localStorage.removeItem(KEY);
  return data.ready ? data : null;
}

export const clearHandoff = () => localStorage.removeItem(KEY);
